import { IsNullOrEmptyHtml } from "helpers/stringHelper";
import { AdditionalMessageDisplayProps } from "../types/email-template.type";

export const AdditionalMessageDisplay: React.FC<
	AdditionalMessageDisplayProps
> = ({ additional_message, className, renderRow = true }) => {
	if (IsNullOrEmptyHtml(additional_message)) {
		return <></>;
	}

	return renderRow ? (
		<tr>
			<td
				className={className}
				style={{
					fontFamily: "Arial, sans-serif",
					fontSize: "16px",
					lineHeight: "24px",
					color: "#374151",
					paddingBottom: "20px",
				}}
				dangerouslySetInnerHTML={{ __html: additional_message }}
			/>
		</tr>
	) : (
		<span dangerouslySetInnerHTML={{ __html: additional_message }}></span>
	);
};
